import { render, staticRenderFns } from "./BankWithdrawalLimitsSettings.vue?vue&type=template&id=6121bf2c&scoped=true"
import script from "./BankWithdrawalLimitsSettings.vue?vue&type=script&lang=js"
export * from "./BankWithdrawalLimitsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6121bf2c",
  null
  
)

export default component.exports